/**
 * USE AUTH HOOK v1.2
 *
 * Universeller Auth-Hook für Web und Native
 *
 * Verwendet automatisch:
 * - useLogto (@logto/react) für Web
 * - useNativeAuth (@logto/capacitor) für Native Apps
 *
 * Die API ist identisch, sodass der Rest der App
 * keine Unterscheidung machen muss.
 *
 * ✅ v1.2: FIX - Prüft platform !== 'web' zusätzlich zu isNativePlatform
 *
 * WICHTIG: Die Hooks werden auf Modulebene ausgewählt,
 * um React's Rules of Hooks einzuhalten.
 */

import { Capacitor } from '@capacitor/core';

const platform = Capacitor.getPlatform();
const isNativePlatform = Capacitor.isNativePlatform();

// ✅ v1.2: FIX - Nur wenn WIRKLICH native (nicht 'web')
const isNative = isNativePlatform && platform !== 'web';

// ✅ v1.1: Bedingte Imports auf Modulebene (nicht in Hook-Funktion)
// Dies erfüllt React's Rules of Hooks, da der Hook selbst nicht bedingt aufgerufen wird

let useAuth;

if (isNative) {
  // Native: Importiere und verwende NativeAuthContext
  console.log('🔐 useAuth: Loading NativeAuth for platform:', platform);
  const { useNativeAuth } = require('../context/NativeAuthContext');
  useAuth = useNativeAuth;
} else {
  // Web: Importiere und verwende LogtoProvider
  console.log('🔐 useAuth: Loading Web Auth (useLogto) for platform:', platform);
  const { useLogto } = require('@logto/react');
  useAuth = useLogto;
}

export { useAuth };
export default useAuth;